<template>
  <div>
    <v-text-field ref="fileTextField" v-model="filename"
                  prepend-icon="attach_file" readonly clearable single-line :label="label"
                  :required="required"
                  :disabled="disabled" @click.native="onFocus" @click:clear="clearFiles()"
    />
    <input ref="fileInput" type="file" :accept="accept" :multiple="true"
           :disabled="disabled" @change="onFileChange"
    >
    <chips-drive
      ref="chipsDrive"
      :cliente="cliente"
      :instalacion="instalacion"
      :incidencia="incidencia"
    />
  </div>
</template>

<script>
import ChipsDrive from '@/components/ChipsDrive'

export default{
  name: 'Drive',
  components: { ChipsDrive },
  props: {
    value: { type: [Array, String],
      default: ''
    },
    accept: {
      type: String,
      default: '*'
    },
    label: {
      type: String,
      default: 'Seleccione los archivos a subir...'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean, // not yet possible because of data
      default: true
    },
    cliente: {
      type: Number,
      default: 0
    },
    instalacion: {
      type: Number,
      default: 0
    },
    incidencia: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      filename: '',
      files: [],
      form: '',
      getFilesServer: []
    }
  },
  watch: {
    value (v) {
      this.filename = v
    }
  },
  mounted () {
    this.filename = this.value
  },
  methods: {
    getFormData (files) {
      const data = new FormData();
      [...files].forEach(file => {
        data.append('data', file, file.name) // currently only one file at a time
      })
      return data
    },
    onFocus () {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFileChange ($event) {
      if (this.files) {
        for (let x = 0; x < $event.target.files.length; x++) {
          if ($event.target.files[x].size <= 4194304) {
            this.files.push($event.target.files[x])
          } else {
            this.$notify({ message: `El archivo ${$event.target.files[x].name} es superior a 4 MB.`, type: 'error' })
          }
        }
      } else {
        this.files = []
        for (let x = 0; x < $event.target.files.length; x++) {
          if ($event.target.files[x].size <= 4194304) {
            this.files.push($event.target.files[x])
          } else {
            this.$notify({ message: `El archivo ${$event.target.files[x].name} es superior a 4 MB.`, type: 'error' })
          }
        }
      }

      this.form = this.getFormData(this.files)

      if (this.files) {
        if (this.files.length > 0) {
          this.filename = [...this.files].map(file => file.name).join(', ')
        } else {
          this.filename = null
        }
      } else {
        this.filename = $event.target.value.split('\\').pop()
      }
      this.$emit('input', this.filename)
      this.$emit('formData', this.form)
    },
    returnFiles () {
      return this.files
    },
    getFiles (data) {
      this.getFilesServer = []
      for (let v = 0; v < data.length; v++) {
        this.getFilesServer.push(data[v])
      }
    },
    sendFiles (inci, idCardTrello) {
      this.files = this.returnFiles()
      let formData = new FormData()
      for (var z = 0; z < this.files.length; z++) {
        formData.append('file', this.files[z])
      }
      this.axios
        .post(this.$apiUrl('file') + `?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${inci}`, formData, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(resp => {
          if (idCardTrello != null && idCardTrello !== undefined && idCardTrello !== '') {
            formData.append('cardId', idCardTrello)
            this.axios
              .post(this.$apiUrl('uploadTrelloFile'), formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(resp => {
                // console.log(resp)
              })
            this.clearFiles()
          }
        })
    },
    loadChips (cliente, instalacion, incidencia) {
      this.$refs.chipsDrive.loadFiles(cliente, instalacion, incidencia)
    },
    clearFiles () {
      this.files = ''
      this.filename = ''
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  position: absolute;
  left: -99999px;
}
#modalPNG {
  display: none;
}
#modalPDF {
  display: none;
}
#modalXML {
  display: none;
}
</style>
